import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {UserService} from '../services/user/user.service';
import {NavigationService} from '../services/nav/navigation.service';
import {MyCognitoUser} from '../cognito-user-interfaces';
import {UserControllerService, UserDto} from '@api/utisha-backend';
import UserTypeEnum = UserDto.UserTypeEnum;
import {MessageService} from '../services/message/message.service';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard  {
  loggedIn: boolean;

  constructor(private userService: UserService,
              private userControllerService: UserControllerService,
              private messageService: MessageService,
              private navService: NavigationService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.userService.getUser();
    if (user) {
      // if (!user.userType) {
      //   console.log('No usertype found');
      //   if (!this.userService.intentUserType) {
      //     this.selectUserType(UserTypeEnum.Student);
      //   } else {
      //     this.selectUserType(this.userService.intentUserType);
      //   }
      //   this.userService.refresh();
      //   return Promise.resolve(false);
      // }
      if (user.userType === UserTypeEnum.Teacher) {
        const isAdmin = await this.userService.isAdmin();
        if (isAdmin) {
          this.navService.defaultAdminPage();
        } else {
          this.navService.defaultTeacherPage();
        }
      } else {
        this.navService.defaultStudentPage();
      }
      return Promise.resolve(false);
    }

    // this.navService.defaultPublicPage();
    return Promise.resolve(false);
  }

  selectUserType(userType: UserTypeEnum): void {
    // this.userControllerService.selectUserType(userType).subscribe({
    //   next: () => {
    //     this.messageService.success('Update successful');
    //     this.userService.refresh();
    //     this.navService.defaultPublicPage();
    //   },
    //   error: (err) => {
    //     this.messageService.error(err.message || err.error);
    //   }
    // });
  }
}
